var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-button',{staticClass:"uppercase flex w-full md:w-auto md:mt-0 mt-4 font-normal text-sm",attrs:{"type":"primary"},on:{"click":_vm.createPost}},[_c('feather-icon',{staticClass:"mr-2",attrs:{"icon":"PlusIcon","svgClasses":"w-4 h-4"}}),_vm._v("Create Post")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }